<template>
    <div v-if="copyNode">
        <b-row class="mt-3">
            <b-col md="6">
                <label for="item-title">Item Title:</label>
                <b-form-input
                    id="item-title"
                    v-model="copyNode.title"
                    :state="nameState"
                    aria-describedby="input-live-help input-live-feedback"
                    placeholder="Enter your name"
                    trim/>
                <b-form-invalid-feedback id="input-live-feedback">
                    Enter at least 3 letters
                </b-form-invalid-feedback>
            </b-col>
            <b-col md="6">
                <label for="item-shortName">Short Name:</label>
                <b-form-input
                    id="item-shortName"
                    v-model="copyNode.shortName"
                    placeholder="Enter Short Name"
                    trim/>
            </b-col>
        </b-row>

        <b-row class="mt-3">
            <b-col md="auto" class="m-auto">
                <b-form-checkbox switch
                    v-model="copyNode.alwaysAvailable">Always Available</b-form-checkbox>                
            </b-col>
            <b-col>
                <label for="item-price">Price:</label>
                <b-form-input
                    id="item-price"
                    type="number"
                    min="0"
                    step="0.01"
                    v-model="copyNodePrice"
                    placeholder="Enter Price"
                    trim/>
            </b-col>
        </b-row>

        <div v-if="!copyNode.alwaysAvailable">
            <location-hours-day v-model="copyNode.hours.monday" dayTitle="Monday" />     
            <location-hours-day v-model="copyNode.hours.tuesday" dayTitle="Tuesday" />     
            <location-hours-day v-model="copyNode.hours.wednesday" dayTitle="Wednesday" />      
            <location-hours-day v-model="copyNode.hours.thursday" dayTitle="Thursday"/>      
            <location-hours-day v-model="copyNode.hours.friday" dayTitle="Friday"/>     
            <location-hours-day v-model="copyNode.hours.saturday" dayTitle="Saturday" />    
            <location-hours-day v-model="copyNode.hours.sunday" dayTitle="Sunday" />
        </div>

        <label for="item-info" class="mt-3">Info:</label>
        <b-form-textarea
            id="item-info"
            v-model="copyNode.info"
            placeholder="Enter Info"
            rows="3"
            trim/>

        <label for="item-description" class="mt-3">Description:</label>
        <b-form-textarea
            id="item-description"
            v-model="copyNode.description"
            placeholder="Enter Description"
            rows="3"
            trim/>
        <div v-if="copyNode.media">                         
            <b-row>
                <b-col md="6">                   
                    <b-img-lazy v-if="copyNode.media.squareUrl"
                            thumbnail fluid :src="copyNode.media.squareUrl" />                    
                    <b-aspect aspect="1:1" v-else-if="copyNode.media.thumbNail" style="width:200px">
                        <b-img-lazy thumbnail fluid :src="copyNode.media.thumbNail" style="object-fit: cover; width: 100%; height: 100%;"/>
                    </b-aspect>
                </b-col>
                <b-col md="6">
                    <b-img-lazy v-if="copyNode.media.rectangleUrl" thumbnail fluid :src="copyNode.media.rectangleUrl" />
                    <b-img-lazy v-else-if="copyNode.media.thumbNail" thumbnail fluid :src="copyNode.media.thumbNail" />
                </b-col>            
            </b-row>
        </div>

        <b-button variant="outline-primary" class="mt-2" v-b-modal.itemImagesModal>Set Image</b-button>
        <br/>

        <b-button size="sm" 
                  class="mt-2 float-right"
                  variant="outline-primary"
                  @click="onSubmit"
                  :disabled="!nameState">Submit</b-button>
        <b-button size="sm" 
                  class="m-2 float-right"
                  variant="outline-danger"
                  @click="$emit('onCancel')">Cancel</b-button>
        <p class="text-danger mt-2 float-right">{{submitError}}</p>

        <b-modal
            size="xl" hide-footer
            id="itemImagesModal" 
            ref="itemImagesModal"
            centered
            :title="'Choose Image For ' + copyNode.title"
            no-close-on-backdrop>
            <photo-library
                @onSelectImage="onSelectImage"
                :fileChooser="true" />
        </b-modal>
    </div>
</template>

<script>
import PhotoLibrary from '@/views/portal/PhotoLibrary';
import LocationHoursDay from "@/components/portal/LocationHoursDay"
import Vue from 'vue'
const moment = require('moment-timezone');

let validateLocationHours = (hours) => {
	let {monday, tuesday, wednesday, thursday, friday,  saturday, sunday} = hours;
	const displayFormat = "hh:mma";

	let dateRange = (day, dayOfWeek, format) => {
		let dateRanges = [];
		day.forEach((hour) => {
			let {startTime, endTime} = typeof(hour) === "object" ? hour : JSON.parse(hour);
			let stTime = moment(startTime, displayFormat);
			let enTime = moment(endTime, displayFormat);
			if(stTime.isValid() && enTime.isValid()) {
				stTime = stTime.day(dayOfWeek);
				enTime = enTime.day(dayOfWeek);
				if(stTime.isAfter(enTime)){
					enTime.add(1, "days");
				}
				if(format){
					dateRanges.push({ startTime : stTime.format(displayFormat), endTime : enTime.format(displayFormat) });
				}else{
					dateRanges.push({ startTime : stTime, endTime : enTime });
				}
			}
		});
		return dateRanges;
	}

	let isValidate = (dateRanges) => {
		let previous = null;
		let index = 0;
		for (let t of dateRanges) {
            if (previous && (!t.startTime || !previous.endTime || t.startTime.isBefore(previous.endTime))) {
                return index;
            }
            index++;
            previous = t;
        }
        return -1;
	}

	let dateRanges = [];
	dateRanges.push(...dateRange(sunday, 0, false));
	dateRanges.push(...dateRange(monday, 1, false));
	dateRanges.push(...dateRange(tuesday, 2, false));
	dateRanges.push(...dateRange(wednesday, 3, false));
	dateRanges.push(...dateRange(thursday, 4, false));
	dateRanges.push(...dateRange(friday, 5, false));
	dateRanges.push(...dateRange(saturday, 6, false));
	dateRanges.push(...dateRange(sunday, 7, false));
	
	let inValidIndex = isValidate(dateRanges);

	if (inValidIndex >= 0) {
		let dateRange = dateRanges[inValidIndex];		
		let startTimeString = !dateRange.startTime ? "" : dateRange.startTime.format("dddd hh:mma");
		let endTimeString = !dateRange.endTime ? "" : dateRange.endTime.format(displayFormat);
		let msg = !startTimeString || !endTimeString ? "Invalid Input" : `Overlaping to ahead time of ${startTimeString}-${endTimeString}`;
		return { sts : false, msg : msg };
	}

	let newHours = { monday:[], tuesday:[], wednesday:[], thursday:[], friday:[],  saturday:[], sunday:[] }
	newHours.monday.push(...dateRange(monday, 1, true));
	newHours.tuesday.push(...dateRange(tuesday, 2, true));
	newHours.wednesday.push(...dateRange(wednesday, 3, true));
	newHours.thursday.push(...dateRange(thursday, 4, true));
	newHours.friday.push(...dateRange(friday, 5, true));
	newHours.saturday.push(...dateRange(saturday, 6, true));
	newHours.sunday.push(...dateRange(sunday, 7, true));
	return { sts : true , newHours : newHours };
}

export default {
    name : 'TreeMenuItem',
    components:{ PhotoLibrary, LocationHoursDay },
    props : ['node'],
    data() { return { copyNode : null , submitError : "" } },
    computed : {
        nameState() {
            return this.copyNode && this.copyNode.title && this.copyNode.title.length > 2 ? true : false
        },
        copyNodePrice : {
            get() {
               return this.copyNode.price / 100.0
            },
            set(newVale) {
                // SJC: I changed this from floor to round.  floors was a problem if you tried to enter 10.2 --> changted to 10.19
                this.copyNode.price = Math.round(newVale * 100.0)
            }
        }
    },
    watch : {
        node : {
            deep: true,
            handler() {
                this.setDefault();
            }
        }
    },
    created() { },
    mounted() {
        this.$nextTick(() => {
            this.setDefault();
        })
    },
    destroyed() { },
    methods: {
        setDefault() {
            let copyNode = null;
            if(this.node.method === "addChild") {
                copyNode = { }
            } else {
                copyNode = this.$deepCopy(this.node.node);
            }
            if(!copyNode.title){
                copyNode.title = ""
            }
            if(!copyNode.hours){
                copyNode.hours = { monday:[], tuesday:[], wednesday:[], thursday:[], friday:[], saturday:[], sunday:[] }
            }
            if(!copyNode.price){
                copyNode.price = 0
            }
            if(!copyNode.optionGroups){
                copyNode.optionGroups = []
            }
            if(copyNode.alwaysAvailable === undefined){
               copyNode.alwaysAvailable = true;
            }
            if(copyNode.media === undefined){
                copyNode.media = null;
            }
            this.copyNode = Vue.observable(copyNode);
        },
        openPhotoLibrary() {
            this.$bvModal.show("itemImagesModal")
        },
        onSubmit() {
            this.submitError = "";
            if(!this.copyNode.alwaysAvailable) {
                let {sts, msg, newHours} = validateLocationHours(this.copyNode.hours);            
                if(!sts) {
                    this.submitError = msg;
                    return;
                } else {
                    this.copyNode.hours = newHours;
                }     
            }
            this.$emit("onSubmit", this.copyNode)
        },
        onSelectImage(media) {
            this.copyNode["media"] = media
            console.log("after", this.copyNode)
            this.$bvModal.hide("itemImagesModal");
        } 
    },
}
</script>

<style scoped lang="scss">

</style>